import {Component, Input, OnInit} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {IconDefinition} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'full-button',
  imports: [FontAwesomeModule, FormsModule],
  templateUrl: './full-button.html',
  standalone: true,
  styleUrls: ['./full-button.component.css']
})
export class FullButtonComponent implements OnInit {
  @Input('marginRight') marginRight: boolean = false
  @Input('text') text: string = ''
  @Input('customClass') class: string = `background: ${localStorage.getItem('primaryColor')}; border-radius: 0.5rem; padding: 0.50rem 0.75rem; color: rgb(255 255 255); text-align: center;`
  @Input('disabledClass') disabledClass: string = 'bg-gray-400 rounded-lg py-2 px-3 text-center'
  @Input('disabled') disabled: boolean = false
  @Input('addToClass') addToClass: string = ''
  @Input('faIcon') faIcon:  IconDefinition | null = null
  @Input('fullWidth') fullWidth: boolean = false

  ngOnInit() {
    if(this.marginRight)
      this.class += ` margin-right: 0.50rem;`
    if(this.addToClass !== '')
      this.class += ' ' + this.addToClass
    if(this.fullWidth) {
      this.disabledClass += ' w-full'
      this.class += ' width: 100%;'
    }
  }
}
